class ItemMovimentacaoModel {

    numero_documento: string | null;
    numero_nota: string | null;
    data_emissao: string | null;
    empresa: string | null;
    id_cliente: number | null;
    codigo_cliente: string | null;
    observacoes: string | null;
    posicao: number | null;

    constructor(numero_documento: string, numero_nota: string, data_emissao: string, empresa: string,
                id_cliente: number, codigo_cliente: string, observacoes: string, posicao: number) {
        this.numero_documento = numero_documento;
        this.numero_nota = numero_nota
        this.data_emissao = data_emissao;
        this.empresa = empresa;
        this.id_cliente = id_cliente;
        this.codigo_cliente = codigo_cliente;
        this.observacoes = observacoes;
        this.posicao = posicao;
    }

}

export default ItemMovimentacaoModel;
